import { useCallback, useEffect } from 'react';

import {
    type A11yAnnouncement,
    currentPageActions,
} from '../store/slices/currentPage/currentPageSlice';
import { useAppDispatch } from './useThunkDispatch';

export const useA11yAnnouncerDispatch = () => {
    const dispatch = useAppDispatch();

    const a11yAnnounceDispatch = useCallback(
        (value: A11yAnnouncement) => {
            dispatch(currentPageActions.setA11yAnnouncement(value));
        },
        [dispatch],
    );

    return a11yAnnounceDispatch;
};

export const useA11yAnnouncerDispatchEffect = (value: A11yAnnouncement) => {
    const dispatchA11yAnnouncer = useA11yAnnouncerDispatch();

    useEffect(() => {
        if (!value) {
            return;
        }

        dispatchA11yAnnouncer(value);
    }, [dispatchA11yAnnouncer, value]);
};
